// extracted by mini-css-extract-plugin
module.exports = {"Navigator":"Navigator_Navigator__1_xFC"};